export default __webpack_public_path__ + "alberta-dot-no.5622ef93b252eddabd74.svg";